<template>
  <div class="auth-container">
    <div class="card">
      <div class="card-header">
        <ul class="nav nav-tabs card-header-tabs">
          <li class="nav-item">
            <a class="nav-link" :class="{ active: activeTab === 'login' }" 
               href="#" @click.prevent="activeTab = 'login'">登录</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" :class="{ active: activeTab === 'register' }" 
               href="#" @click.prevent="activeTab = 'register'">注册</a>
          </li>
        </ul>
      </div>
      <div class="card-body">
        <!-- 登录表单 -->
        <div v-if="activeTab === 'login'">
          <h3 class="card-title mb-4">账号登录</h3>
          <form @submit.prevent="handleLogin">
            <div class="mb-3">
              <label for="loginUsername" class="form-label">用户名</label>
              <input 
                type="text" 
                class="form-control" 
                id="loginUsername" 
                v-model="loginForm.username" 
                required
                placeholder="请输入用户名"
              >
            </div>
            <div class="mb-3">
              <label for="loginPassword" class="form-label">密码</label>
              <input 
                type="password" 
                class="form-control" 
                id="loginPassword" 
                v-model="loginForm.password" 
                required
                placeholder="请输入密码"
              >
            </div>
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="rememberMe" v-model="loginForm.remember">
                <label class="form-check-label" for="rememberMe">记住我</label>
              </div>
              <a href="#" class="text-decoration-none">忘记密码?</a>
            </div>
            <div class="alert alert-danger" v-if="loginError">{{ loginError }}</div>
            <button type="submit" class="btn btn-primary w-100" :disabled="isSubmitting">
              <span v-if="isSubmitting">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                登录中...
              </span>
              <span v-else>登录</span>
            </button>
          </form>
        </div>

        <!-- 注册表单 -->
        <div v-if="activeTab === 'register'">
          <h3 class="card-title mb-4">创建账号</h3>
          <form @submit.prevent="handleRegister">
            <div class="mb-3">
              <label for="registerUsername" class="form-label">用户名</label>
              <input 
                type="text" 
                class="form-control" 
                id="registerUsername" 
                v-model="registerForm.username" 
                required
                placeholder="请输入用户名"
              >
            </div>
            <div class="mb-3">
              <label for="registerEmail" class="form-label">电子邮箱</label>
              <input 
                type="email" 
                class="form-control" 
                id="registerEmail" 
                v-model="registerForm.email" 
                required
                placeholder="请输入电子邮箱"
              >
            </div>
            <div class="mb-3">
              <label for="registerPassword" class="form-label">密码</label>
              <input 
                type="password" 
                class="form-control" 
                id="registerPassword" 
                v-model="registerForm.password" 
                required
                placeholder="请输入密码"
              >
            </div>
            <div class="mb-3">
              <label for="confirmPassword" class="form-label">确认密码</label>
              <input 
                type="password" 
                class="form-control" 
                id="confirmPassword" 
                v-model="registerForm.confirmPassword" 
                required
                placeholder="请再次输入密码"
              >
            </div>
            <div class="alert alert-danger" v-if="registerError">{{ registerError }}</div>
            <button type="submit" class="btn btn-success w-100" :disabled="isSubmitting">
              <span v-if="isSubmitting">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                注册中...
              </span>
              <span v-else>注册</span>
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCurrentInstance } from 'vue';

export default {
  name: 'Auth',
  data() {
    return {
      activeTab: 'login',
      isSubmitting: false,
      loginError: '',
      registerError: '',
      loginForm: {
        username: '',
        password: '',
        remember: false
      },
      registerForm: {
        username: '',
        email: '',
        password: '',
        confirmPassword: ''
      }
    };
  },
  methods: {
    async handleLogin() {
      // 登录表单验证
      if (!this.loginForm.username || !this.loginForm.password) {
        this.loginError = '请填写用户名和密码';
        return;
      }

      this.isSubmitting = true;
      this.loginError = '';
      
      try {
        // 这里将来会调用API登录
        // 模拟API调用延迟
        await new Promise(resolve => setTimeout(resolve, 1000));
        
        // 创建用户对象
        const user = {
          username: this.loginForm.username,
          token: 'sample-token-' + Date.now(),
          isLoggedIn: true
        };
        
        // 假设登录成功，存储用户信息到本地存储
        localStorage.setItem('user', JSON.stringify(user));
        
        // 获取事件总线实例
        const { proxy } = getCurrentInstance();
        // 触发登录事件，通知App组件更新用户状态
        proxy.emitter.emit('user-logged-in', user);
        
        // 登录成功后跳转到首页
        this.$router.push('/');
        
        // 登录成功消息可以用alert或者toast组件
        alert('登录成功！');
      } catch (error) {
        console.error('登录失败:', error);
        this.loginError = '登录失败，请检查用户名和密码';
      } finally {
        this.isSubmitting = false;
      }
    },
    
    async handleRegister() {
      // 注册表单验证
      if (!this.registerForm.username || !this.registerForm.email || !this.registerForm.password) {
        this.registerError = '请填写所有必填字段';
        return;
      }
      
      if (this.registerForm.password !== this.registerForm.confirmPassword) {
        this.registerError = '两次输入的密码不一致';
        return;
      }
      
      this.isSubmitting = true;
      this.registerError = '';
      
      try {
        // 这里将来会调用API注册
        // 模拟API调用延迟
        await new Promise(resolve => setTimeout(resolve, 1000));
        
        // 假设注册成功，切换到登录标签
        this.activeTab = 'login';
        
        // 清空表单
        this.registerForm = {
          username: '',
          email: '',
          password: '',
          confirmPassword: ''
        };
        
        // 注册成功消息
        alert('注册成功！请使用新账号登录');
      } catch (error) {
        console.error('注册失败:', error);
        this.registerError = '注册失败，请稍后再试';
      } finally {
        this.isSubmitting = false;
      }
    }
  }
};
</script>

<style scoped>
.auth-container {
  max-width: 500px;
  margin: 3rem auto;
  padding: 0 15px;
}

.card {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.card-header {
  background-color: #f8f9fa;
  border-bottom: none;
}

.nav-tabs .nav-link {
  color: #6c757d;
  border: none;
  padding: 1rem;
}

.nav-tabs .nav-link.active {
  color: #007bff;
  border-bottom: 2px solid #007bff;
  font-weight: 500;
}

.card-body {
  padding: 2rem;
}

.btn {
  padding: 0.6rem;
}
</style> 